// extracted by mini-css-extract-plugin
export var link = "pane-desktop-module--link--2573d";
export var linkActive = "pane-desktop-module--linkActive--e9a8c";
export var list = "pane-desktop-module--list--bac4c";